export default __webpack_public_path__ + "static/media/AppHome.8446288d.png";